import React, { useState } from "react";
import {
  applyAuthExperienceSwitchUrlParam,
  getBootstrapExperience,
  writeLoginExperience,
} from "../common/loginExperienceStorage";
import EmailIdentify from "../sso/EmailIdentify";
import ClassicLogin from "./ClassicLogin";

/**
 * Renders classic or progressive login based on localStorage/bootstrap preference.
 */
export default function LoginExperienceRouter(props) {
  // Apply URL param before reading experience so `=false` can reset to classic.
  const [showExperienceSwitcher] = useState(() =>
    applyAuthExperienceSwitchUrlParam()
  );
  const [experience, setExperience] = useState(() => getBootstrapExperience());

  const handleExperienceChange = (next) => {
    const mode = writeLoginExperience(next);
    if (typeof document !== "undefined") {
      document.documentElement.dataset.loginExperience = mode;
    }
    setExperience(mode);
  };

  const experienceProps = {
    experience,
    onExperienceChange: handleExperienceChange,
    showExperienceSwitcher,
  };

  if (experience === "progressive") {
    return <EmailIdentify {...props} {...experienceProps} />;
  }

  return <ClassicLogin {...props} {...experienceProps} />;
}
